exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question-content img{max-width:100%;width:100%}", ""]);

// exports
